import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { formatNumber2 } from 'utils/currencyFormat';
import { getDate, currentDate, formatDayMonth } from 'utils/formatDate';
import InLanDongLai from './inLanDongLaiXemTruoc';
export const ModalDongLaiXemTruoc = (props) => {


    const divRef = React.useRef();

    useEffect(() => {
        console.log(divRef.current);
    }, [divRef]);

    // const loadDivIn = () => {
    //     if (divRef && divRef.current) {
    //         divRef.current.focus();

    //     }
    //     // if (divRef.current === null) {
    //     //     divRef.current = new IntersectionObserver();
    //     //   }
    //     // console.log(divRef.current.outerHTML);
    // };

    const renderRow = () => {
        let khoanvay = props.thongtinThanhToanXemTruoc.TongTienGoc;
        let nogoconlai = 0;
        return props.listPaid.map((item, index) => {
            if (index > 1)
                khoanvay = nogoconlai;
            nogoconlai = khoanvay - item.ValueGoc;
            return (
                <>
                    <tr>
                        <td>{index + 1}</td>
                        <td>  {getDate(item.Time)}</td>
                        <td><p class="text-right"><a>{formatNumber2(item.ValuePaid)}</a></p></td>
                        <td><p class="text-right">{formatNumber2(item.ValueGoc)}</p></td>
                        <td><p class="text-right">{formatNumber2(item.OtheFee)}</p></td>
                        {props.thongtinThanhToanXemTruoc.TongPhiKho > 0 && (
                            <td><p class="text-right">{formatNumber2(item.PhiKho)}</p></td>
                        )}
                        {props.thongtinThanhToanXemTruoc.TongPhiPhat > 0 && (
                            <td><p class="text-right">{formatNumber2(item.Amercement)}</p></td>
                        )}
                        {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                            <td>
                                <p class="text-right">{formatNumber2(khoanvay)}</p>
                            </td>
                        )}
                        {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                            <td>
                                <p class="text-right">{formatNumber2(nogoconlai)}</p>
                            </td>
                        )}
                        <td> <p class="text-right">{formatNumber2(
                            item.ValueGoc +
                            item.ValuePaid +
                            (item.OtheFee ? +item.OtheFee : 0) +
                            (item.Amercement ? +item.Amercement : 0)
                            + (item.PhiKho == null ? 0 : item.PhiKho)
                        )}</p></td>
                    </tr>
                </>
            );
        });
    }
    const renderRowIn = () => {
        let khoanvay = props.thongtinThanhToanXemTruoc.TongTienGoc;
        let nogoconlai = 0;
        return props.listPaid.map((item, index) => {
            if (index > 1)
                khoanvay = nogoconlai;
            nogoconlai = khoanvay - item.ValueGoc;
            return (
                <>
                    <tr>
                        <td style={{ borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}>{index + 1}</td>
                        <td style={{ borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}>{getDate(item.Time)}</td>
                        <td style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}><p class="text-right" style={{margin:"2px",padding: "2px"}}><a>{formatNumber2(item.ValuePaid)}</a></p></td>
                        <td style={{ textAlign: "right", textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}><p class="text-right"  style={{margin:"2px",padding: "2px"}}>{formatNumber2(item.ValueGoc)}</p></td>
                        <td style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}><p class="text-right"  style={{margin:"2px",padding: "2px"}}>{formatNumber2(item.OtheFee)}</p></td>
                        {props.thongtinThanhToanXemTruoc.TongPhiKho > 0 && (
                            <td style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}><p class="text-right"  style={{margin:"2px",padding: "2px"}}>{formatNumber2(item.PhiKho)}</p></td>
                        )}
                        {props.thongtinThanhToanXemTruoc.TongPhiPhat > 0 && (
                            <td style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}><p class="text-right"  style={{margin:"2px",padding: "2px"}}>{formatNumber2(item.Amercement)}</p></td>
                        )}
                        {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                            <td style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}>
                                <p class="text-right"  style={{margin:"2px",padding: "2px"}}>{formatNumber2(khoanvay)}</p>
                            </td>
                        )}
                        {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                            <td style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}>
                                <p class="text-right"  style={{margin:"2px",padding: "2px"}}>{formatNumber2(nogoconlai)}</p>
                            </td>
                        )}
                        <td style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "2px" }}> <p class="text-right"  style={{margin:"2px",padding: "2px"}}>{formatNumber2(
                            item.ValueGoc +
                            item.ValuePaid +
                            (item.OtheFee ? +item.OtheFee : 0) +
                            (item.Amercement ? +item.Amercement : 0)
                            + (item.PhiKho == null ? 0 : item.PhiKho)
                        )}</p></td>
                    </tr>
                </>
            );
        });
    }

    return (
        <Modal
            {...props}
            size="modal-new-size modal-new-size"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left popup-detail"
        >
              <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
            Lịch thanh toán chi phí vay
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
            <Modal.Body>
                <form className="form tat-toan">
                    <div className="form-body">
                        <div className="card collapse-icon accordion-icon-rotate">
                            <div
                                id="collapse53"
                                aria-labelledby="headingCollapse53"
                                className="card-collapse collapse show"
                                aria-expanded="true"
                            >
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div class="table-responsive table-responsive-new table-new1">
                                                    <table className="table table-bordered Table-main-new">
                                                        <thead>
                                                            <tr>
                                                                <th  className="color7-bold">STT <br /><span className="color-do-bold">[{props.thongtinThanhToanXemTruoc.TongBanGhi}]</span>
                                                                </th>
                                                                <th  className="color7-bold">Ngày trả lãi</th>
                                                                <th  className="color7-bold" style={{ textAlign: "right" }}>Chi phí vay
                                                                    <br />
                                                                    <span className="color-do-bold">{formatNumber2(props.thongtinThanhToanXemTruoc.TongChiPhiVay)}</span>
                                                                </th>
                                                                <th  className="color7-bold" style={{ textAlign: "right" }}>Tiền gốc <br />
                                                                    <span className="color-do-bold">{formatNumber2(props.thongtinThanhToanXemTruoc.TongTienGoc)}</span></th>
                                                                <th  className="color7-bold" style={{ textAlign: "right" }}>Phí khác <br />
                                                                    <span className="color-do-bold">{formatNumber2(props.thongtinThanhToanXemTruoc.TongPhiKhac)}</span></th>
                                                                {props.thongtinThanhToanXemTruoc.TongPhiKho > 0 && (
                                                                    <th   className="color7-bold"style={{ textAlign: "right" }}>Phí kho <br />
                                                                        <span className="color-do-bold">{formatNumber2(props.thongtinThanhToanXemTruoc.TongPhiKho)}</span></th>
                                                                )}
                                                                {props.thongtinThanhToanXemTruoc.TongPhiPhat > 0 && (
                                                                    <th   className="color7-bold" style={{ textAlign: "right" }}>Phí phạt <br />
                                                                        <span className="color-do-bold">{formatNumber2(props.thongtinThanhToanXemTruoc.TongPhiPhat)}</span></th>
                                                                )}
                                                                {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                                                                    <th   className="color7-bold" style={{ textAlign: "right" }}>Khoản vay</th>
                                                                )}
                                                                {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                                                                    <th  className="color7-bold" style={{ textAlign: "right" }}>Nợ gốc còn lại</th>
                                                                )}
                                                                <th  className="color7-bold" style={{ textAlign: "right" }}>Cần thanh toán<br />
                                                                    <span className="color-do-bold">{formatNumber2(props.thongtinThanhToanXemTruoc.TongCanThanhToan)}</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {renderRow()}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div style={{ display: "none" }}>
                                                    <div ref={divRef} id="divDongLaiXemTruoc">
                                                        <p style={{ width: "100%", textAlign: "center" }}>LỊCH THANH TOÁN CHI PHÍ VAY</p>
                                                        <table style={{ borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", width: "99%", borderCollapse: "collapse" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>STT <br /><span className="red">[{props.thongtinThanhToanXemTruoc.TongBanGhi}]</span>
                                                                    </th>
                                                                    <th style={{ borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Ngày trả lãi</th>
                                                                    <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Chi phí vay
                                                                        <br />
                                                                        <span className="red">{formatNumber2(props.thongtinThanhToanXemTruoc.TongChiPhiVay)}</span>
                                                                    </th>
                                                                    <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Tiền gốc <br />
                                                                        <span className="red">{formatNumber2(props.thongtinThanhToanXemTruoc.TongTienGoc)}</span></th>
                                                                    <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Phí khác <br />
                                                                        <span className="red">{formatNumber2(props.thongtinThanhToanXemTruoc.TongPhiKhac)}</span></th>
                                                                    {props.thongtinThanhToanXemTruoc.TongPhiKho > 0 && (
                                                                        <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Phí kho <br />
                                                                            <span className="red">{formatNumber2(props.thongtinThanhToanXemTruoc.TongPhiKho)}</span></th>
                                                                    )}
                                                                    {props.thongtinThanhToanXemTruoc.TongPhiPhat > 0 && (
                                                                        <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Phí phạt <br />
                                                                            <span className="red">{formatNumber2(props.thongtinThanhToanXemTruoc.TongPhiPhat)}</span></th>
                                                                    )}
                                                                    {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                                                                        <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Khoản vay</th>
                                                                    )}
                                                                    {props.thongtinThanhToanXemTruoc.IsDuNoGiamDan == true && (
                                                                        <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Nợ gốc còn lại</th>
                                                                    )}
                                                                    <th style={{ textAlign: "right", borderWidth: "1px", borderColor: "#CCC", borderStyle: "solid", padding: "5px" }}>Cần thanh toán<br />
                                                                        <span className="red">{formatNumber2(props.thongtinThanhToanXemTruoc.TongCanThanhToan)}</span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {renderRowIn()}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className="modal-footer button-popup-new-size">
                {/* <a
                 class="btn btn-new-main btn-closenew"
                    data-dismiss="modal"
                    href={() => false}
                    onClick={props.onHide}
                >
                 <span>
                    <i class="mdi mdi-close"></i>
                  </span>
                  &nbsp; Đóng &nbsp;
                </a> */}
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  href={() => false}
                  o onClick={props.onHide}
                >
                  <span>
                    <i class="mdi mdi-close"></i>
                  </span>
                  &nbsp; Đóng &nbsp;
                </button>
                 <InLanDongLai data={divRef} ></InLanDongLai>
            </Modal.Footer>
        </Modal>
    );
};
